import type { Requests } from "../common/request.common";
import type { AgentInvoiceResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const agentInvoice = {
    record(data: typeof Requests.AgentInvoice.Record.Input) {
        return post<typeof data, AgentInvoiceResponseTypes.Record>(`/agent-invoice/record`, data);
    },
    obtain(id: string) {
        return get<AgentInvoiceResponseTypes.Obtain>(`/agent-invoice/obtain/${id}`);
    },
};
